'use client';

import { FC } from 'react';

import { AutoSuggestResponseContent } from '@ravago/shared/page-data/models/elastic';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { useTranslations } from '@ravago/shared/translations/client';

import { getLanguageCode } from '../../../../utils/locale/locale.utils';
import { AutoSuggestPages } from '../../../shared/auto-suggest/components/auto-suggest-pages';

interface Props {
   productListTitle: string;
   productListAnchor: string;
   locale: string;
   isConsumer: boolean;
   baseRoute?: string;
   suggestions: AutoSuggestResponseContent[];
   productCount: number;
}

/* c8 ignore start */
export const ProductListerBlock: FC<Props> = ({ productListTitle, productListAnchor, locale, isConsumer, baseRoute, suggestions, productCount }) => {
   const translate = useTranslations();

   const onCheckProductsList = () => {
      window.dispatchEvent(new CustomEvent('onCheckProductsList'));

      document.getElementById(productListAnchor)?.scrollIntoView({ behavior: 'smooth' });
   };

   const autoSuggestPages = (
      <>
         <AutoSuggestPages
            title={productListTitle}
            suggestedPages={suggestions}
            itemCount={5}
            language={getLanguageCode(locale)}
            locale={locale}
            isConsumer={isConsumer}
            productLister
            baseRoutes={baseRoute ? { product: baseRoute, caseStudy: '', brand: '' } : undefined}
         />
         {productCount > 5 && (
            <Button disabled={!productListAnchor} onClick={onCheckProductsList} badge={productCount.toString()}>
               {translate('product-lister-block-view-more')}
            </Button>
         )}
      </>
   );

   return (
      <Box spacing="lg" direction="column" background="#FFF" shadow borderRadius="largest">
         {autoSuggestPages}
      </Box>
   );
};
/* c8 ignore end */
